import { render, staticRenderFns } from "./service.vue?vue&type=template&id=33789c57&scoped=true&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./service.vue?vue&type=style&index=0&id=33789c57&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "33789c57",
  "56be35d0"
  
)

export default component.exports